import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useLanguage } from '../context/LanguageContext';

export default function LanguageSyncToast() {
  const { languageToast, clearLanguageToast } = useLanguage();

  const handleClose = (_event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    clearLanguageToast();
  };

  return (
    <Snackbar
      open={Boolean(languageToast.message)}
      autoHideDuration={3500}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity={languageToast.severity} sx={{ width: '100%' }}>
        {languageToast.message}
      </Alert>
    </Snackbar>
  );
}
